export default "__VITE_ASSET__Dcw4VWjN__"